// extracted by mini-css-extract-plugin
export default {"main":"main_main__mpUAZ","fontContainer":"main_fontContainer__NkMMk"};